import IncidentTypeTable from "./components/IncidentTypeTable";

const IncidentTypeComponent = () =>{

    return(
        <IncidentTypeTable />
    )
}
export default IncidentTypeComponent;